import { AuthRoute } from '@/system-modules/auth/v1/api/AuthRoute'
import { EnumRouteType } from '@/contracts/core/api/enum/EnumRouteType'
import { ApiResponse } from '@/contracts/core/api/entity/ApiResponse'
import { PinsParams } from '@/system-modules/auth/v1/api/v1/auth/SetPins/Dto/PinsParams'

export class SetPinsRoute extends AuthRoute<PinsParams, null> {
  type(): EnumRouteType {
    return EnumRouteType.POST
  }

  url(): string {
    return '/api/system/v1/auth/pins'
  }

  offline(params: PinsParams): Promise<ApiResponse<null>> {
    if (params.pin === params.resetPin) {
      return Promise.resolve(new ApiResponse({ success: false, error: 'invalid_pin' }))
    }

    return Promise.resolve(new ApiResponse({ success: true, data: null }))
  }
}
